export default "__VITE_ASSET__CkGZhE_U__"